import { type ReactNode } from "react";
import { ColorSwatch } from "./color-swatch";
import { Badge, type BadgeProps } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface TagChipProps extends Omit<BadgeProps, "variant"> {
  label: string;
  color?: string;
  children?: ReactNode;
  labelClassName?: string;
  swatchClassName?: string;
}

export const TagChip = ({
  label,
  color,
  className,
  children,
  labelClassName,
  swatchClassName,
  ...props
}: TagChipProps) => {
  return (
    <Badge
      data-tag-chip
      variant="outline"
      className={cn(
        "flex items-center gap-1 border-transparent bg-muted/60 text-foreground",
        className,
      )}
      {...props}
    >
      <ColorSwatch color={color} className={swatchClassName} />
      <span className={cn("text-xs", labelClassName)}>{label}</span>
      {children}
    </Badge>
  );
};
